import AsyncStorage from "@react-native-async-storage/async-storage";
import * as DocumentPicker from "expo-document-picker";
import React, { useEffect, useRef, useState } from "react";
import {
  Image,
  ActivityIndicator,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import { FormattedMessage, useIntl } from "react-intl";
import InputDefault from "../../components/Form/InputDefault";
import MaskedInputDefault from "../../components/Form/MaskedInputDefault";
import ScreenLoader from "../../components/ScreenLoader";
import GoBackButton from "../../components/GoBackButton";
import HeaderTabs from "../../components/HeaderTabs";
import { toast } from "../../utils/toast";
import * as mime from "react-native-mime-types";
import api from "../../services/api";
import cepService from "../../services/cepService";
import styles from "./styles";
import ups3 from "../../services/uploadS3";
import { If, Then, Else } from "react-if";

const UpdateRegistration = ({ navigation }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("");

  const [nameLegalResponsible, setNameLegalResponsible] = useState("");
  const [cpfLegalResponsible, setCpfLegalResponsible] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [socialReason, setSocialReason] = useState("");

  const [rg, setRg] = useState("");
  const [cep, setCep] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [complement, setComplement] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [level, setLevel] = useState(1);
  const [pj, setPj] = useState(false);
  const [socialContractLegalResponsible, setSocialContractLegalResponsible] =
    useState(null);
  const [proofAddress, setProofdAddress] = useState(null);
  const [hasPermission, setHasPermission] = useState(null);

  const intl = useIntl();

  const inputNumber = useRef(null);

  useEffect(() => {
    getDataUsers();
  }, []);

  const getDataUsers = async () => {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    api
      .get(`/clients/getDetails/client`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        ({
          data: {
            user: [{ client, ...user }],
            proofAddress,
          },
        }) => {
          setNameLegalResponsible(client.name_legal_responsible || "");
          setCpfLegalResponsible(client.cpf_legal_responsible || "");
          setSocialReason(client.social_reason || "");
          setCnpj(client.cnpj || "");

          setName(client.first_name || "");
          setEmail(client.user.email || "");
          setCpf(client.cpf || "");
          setRg(client.rg_number || "");
          setCep(user.address.zip_code || "");
          setStreet(user.address.street_name || "");
          setNumber(user.address.street_number || "");
          setCountry(client.country || "");

          setDistrict(user.address.district || "");
          setCity(user.address.city || "");
          setState(user.address.state || "");
          setComplement(user.address.additional_information || "");
          setLevel(client.level || "");
          setPj(client.is_pj || false);

          if (proofAddress) setProofdAddress(proofAddress);

          setIsLoading(false);
        }
      )
      .catch((error) => {
        console.error(error);
        toast(
          intl.formatMessage({ id: "updateRegistration.erroGeral" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  };

  const save = async () => {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    let countryId;
    if (country === "italia") {
      countryId = 108;
    } else if (country === "brasil") {
      countryId = 31;
    }
    if (level === 1) {
      const data = {
        name,
        email,
        cpf,
        cnpj,
        social_reason: socialReason,
        name_legal_responsible: nameLegalResponsible,
        cpf_legal_responsible: cpfLegalResponsible,
        rg,
        cep,
        street,
        number,
        country,
        country_id: countryId,
        district,
        city,
        state,
        complement,
      };

      await api
        .patch(`/clients/update/client`, data, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          console.log(res.data, data, "2");
          toast(
            intl.formatMessage({ id: "updateRegistration.dadosAtualizados" }),
            "#080"
          );

          setIsLoading(false);
        })
        .catch((error) => {
          /* toast(
            intl.formatMessage({ id: "updateRegistration.erroGeral" }),
            "#080"
          ); */
          toast(
            intl.formatMessage({ id: "updateRegistration.dadosAtualizados" }),
            "#080"
          );
          setIsLoading(false);
          console.error(error);
        });
    }

    if (level === 2) {
      const fileId = proofAddress && proofAddress.id;
      const data = {
        name,
        email,
        cpf,
        cnpj,
        social_reason: socialReason,
        name_legal_responsible: nameLegalResponsible,
        cpf_legal_responsible: cpfLegalResponsible,
        rg,
        cep,
        street,
        number,
        country,
        country_id: countryId,
        district,
        city,
        state,
        complement,
        fileId,
      };

      await api
        .patch(`/clients/update/client`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          toast(
            intl.formatMessage({ id: "updateRegistration.dadosAtualizados" }),
            "#080"
          );
          setIsLoading(false);
        })
        .catch((error) => {
          toast(
            intl.formatMessage({ id: "updateRegistration.erroGeral" }),
            "#DA1414"
          );
          setIsLoading(false);
          console.log(error);
        });
    }
  };

  const pickDocument = async () => {
    let result = await DocumentPicker.getDocumentAsync({});

    if (result.cancelled) {
      return false;
    }

    let localUri = result.uri;
    let filename = localUri.split("/").pop();

    let match = /\.(\w+)$/.exec(filename);
    let type = match ? `image/${match[1]}` : `image`;

    setSocialContractLegalResponsible(result);
  };

  const pickDocumentAddress = async () => {
    setIsLoading(true);

    const response = await DocumentPicker.getDocumentAsync();

    if (response.type == "cancel") {
      console.log("User cancelled document picker");
    } else if (!response.uri) {
      console.log("DocumentPicker Error Uri: ", response.uri);
    } else {
      let localUri = "file://" + response.uri;
      let filename = localUri.split("/").pop();

      let match = /\.(\w+)$/.exec(filename);
      let type = mime.lookup(localUri);

      var file = {
        uri: localUri.replace(/%/g, "%25"),
        name: response.name,
        type,
        size: response.size,
        path: "ProofAddress",
      };
      await ups3(file).then((res) => {
        if (res) {
          file.id = res.id;
          setProofdAddress(file);
        } else {
          toast(
            intl.formatMessage({ id: "updateRegistration.erroArquivo" }),
            "#DA1414"
          );
        }
        setIsLoading(false);
      });
    }
  };

  const onCepChange = (value) => {
    setCep(value);
    let cepReplace = value.replace(/[^0-9]/g, "");

    if (cepReplace.length == 8) {
      cepService.getAddressFromCEP(cepReplace).then((response) => {
        if (response.status == 200) {
          setStreet(response.data.logradouro);
          setCity(response.data.localidade);
          setState(response.data.uf);
          setDistrict(response.data.bairro);
          setComplement(response.data.complemento);
          inputNumber?.current?.focus();
        }
      });
    }
  };
  return (
    <>
      <HeaderTabs
        title={
          <FormattedMessage id="updateRegistration.titleAtualizarCadastro" />
        }
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="updateRegistration.atualizeSuaConta" />
          </Text>
        }
      />

      <View style={{ flex: 1, flexDirection: "column" }}>
        <ScreenLoader loading={isLoading} />
        <ScrollView>
          <View style={styles.content}>
            <View>
              <Text style={styles.tituloAtualizarCadastro}>
                <FormattedMessage id="updateRegistration.titleAtualizarCadastro" />
              </Text>
            </View>
            {pj ? (
              <>
                <FormattedMessage id="updateRegistration.razaoSocial">
                  {(placeholder) => (
                    <InputDefault
                      editable={false}
                      value={socialReason}
                      onValueChange={(value) => setSocialReason(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.cnpj">
                  {(placeholder) => (
                    <InputDefault
                      editable={false}
                      value={cnpj}
                      onValueChange={(value) => setCnpj(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.nomeResponsavel">
                  {(placeholder) => (
                    <InputDefault
                      editable={false}
                      value={nameLegalResponsible}
                      onValueChange={(value) => setNameLegalResponsible(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.CpfResponsavel">
                  {(placeholder) => (
                    <InputDefault
                      editable={false}
                      value={cpfLegalResponsible}
                      onValueChange={(value) => setCpfLegalResponsible(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>
              </>
            ) : (
              <>
                <FormattedMessage id="updateRegistration.nome">
                  {(placeholder) => (
                    <InputDefault
                      editable={false}
                      value={name}
                      onValueChange={(value) => setName(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.cpf">
                  {(placeholder) => (
                    <MaskedInputDefault
                      editable={false}
                      mask="999.999.999-99"
                      keyboardType="numeric"
                      value={cpf}
                      onValueChange={(value) => setCpf(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.rg">
                  {(msg) => (
                    <InputDefault
                      value={rg}
                      onValueChange={(value) => setRg(value)}
                      placeholder={msg}
                    />
                  )}
                </FormattedMessage>
              </>
            )}

            <FormattedMessage id="updateRegistration.email">
              {(placeholder) => (
                <InputDefault
                  editable={false}
                  value={email}
                  onValueChange={(value) => setEmail(value)}
                  placeholder={placeholder}
                />
              )}
            </FormattedMessage>

            {level >= 1 ? (
              <>
                <FormattedMessage id="updateRegistration.cep">
                  {(placeholder) => (
                    <MaskedInputDefault
                      mask="99999-999"
                      keyboardType="numeric"
                      value={cep}
                      onValueChange={(value) => onCepChange(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.rua">
                  {(placeholder) => (
                    <InputDefault
                      value={street}
                      onValueChange={(value) => setStreet(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.numero">
                  {(placeholder) => (
                    <InputDefault
                      value={number}
                      onValueChange={(value) => setNumber(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="countryselect.Pais">
                  {(placeholder) => (
                    <InputDefault
                      editable={false}
                      value={country}
                      onValueChange={(value) => setCountry(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.bairro">
                  {(placeholder) => (
                    <InputDefault
                      value={district}
                      onValueChange={(value) => setDistrict(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.cidade">
                  {(placeholder) => (
                    <InputDefault
                      value={city}
                      onValueChange={(value) => setCity(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.estado">
                  {(placeholder) => (
                    <InputDefault
                      value={state}
                      onValueChange={(value) => setState(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                <FormattedMessage id="updateRegistration.complemento">
                  {(placeholder) => (
                    <InputDefault
                      value={complement}
                      onValueChange={(value) => setComplement(value)}
                      placeholder={placeholder}
                    />
                  )}
                </FormattedMessage>

                {level >= 2 ? (
                  <View style={styles.containerSocialContract}>
                    <Text style={styles.description}>
                      <FormattedMessage id="updateRegistration.comprovanteEndereco" />
                    </Text>
                    <TouchableOpacity
                      style={styles.btnAdd}
                      onPress={pickDocumentAddress}
                    >
                      <Image
                        source={require("../../../assets/upload_doc.svg")}
                        style={styles.imgUpload}
                      />
                      <Text style={styles.uploadText}>
                        <FormattedMessage id="updateRegistration.fazerUpload" />
                      </Text>
                    </TouchableOpacity>
                    {proofAddress && (
                      <Text style={{ fontWeight: "bold", marginTop: 20 }}>
                        <Text style={{ fontWeight: "normal" }}>
                          <FormattedMessage id="updateRegistration.arquivo" />
                          {proofAddress.name}
                        </Text>
                      </Text>
                    )}
                  </View>
                ) : null}

                {pj ? (
                  <View style={styles.containerSocialContract}>
                    <Text style={styles.description}>
                      <FormattedMessage id="updateRegistration.contratoSocial" />
                    </Text>
                    <TouchableOpacity
                      style={styles.btnAdd}
                      onPress={pickDocument}
                    >
                      <Feather
                        name="plus"
                        size={24}
                        color="black"
                        style={styles.iconAdd}
                      />
                    </TouchableOpacity>
                    <If condition={socialContractLegalResponsible}>
                      <Then>
                        <Text style={{ fontWeight: "bold", marginTop: 20 }}>
                          <Text style={{ fontWeight: "normal" }}>
                            <FormattedMessage id="updateRegistration.arquivo" />{" "}
                            {socialContractLegalResponsible.name}
                          </Text>
                        </Text>
                      </Then>
                    </If>
                  </View>
                ) : null}
              </>
            ) : null}
            <View style={styles.contentBtn}>
              <TouchableOpacity onPress={save} style={styles.btn}>
                <If condition={isLoading}>
                  <Then>
                    <ActivityIndicator color="#2797A2" size="small" />
                  </Then>
                  <Else>
                    <Text style={styles.textBtn}>
                      <FormattedMessage id="updateRegistration.salvar" />
                    </Text>
                  </Else>
                </If>
              </TouchableOpacity>
            </View>
          </View>

          <View style={styles.contentBtnDelete}>
            <TouchableOpacity
              onPress={() => navigation.navigate("DeleteAccount")}
              style={{ marginBottom: 12 }}
            >
              <Text style={styles.textBtnDelete}>
                <FormattedMessage id="deleteAccount.headerExcluiConta" />
              </Text>
            </TouchableOpacity>
            <GoBackButton />
          </View>
        </ScrollView>
      </View>
    </>
  );
};
export default UpdateRegistration;
